import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import * as React from "react"
import { classNames } from "../../../utils/classNames"

export type HorizontalTab<ValueType = string> = {
    id: ValueType
    label: string
    isDisabled?: boolean
}

export type HorizontalTabsProps<ValueType = string> = {
    className?: string
    tabs: HorizontalTab<ValueType>[]
    extraContent?: Maybe<React.ReactNode | string>
    value?: ValueType
    onChange: (value: ValueType) => void
}

export const HorizontalTabs = <TabType extends string>(props: HorizontalTabsProps<TabType>) => {
    return (
        <div className={classNames(classes.tabs.wrap, props.className)}>
            {props.tabs.map(t => {
                const isActive = props.value ? props.value === t.id : false
                return (
                    <button
                        key={t.id}
                        type="button"
                        onClick={() => props.onChange(t.id)}
                        className={classNames(
                            classes.tabs.tab,
                            isActive && classes.tabs.tabActive,
                            t.isDisabled && classes.tabs.disabled
                        )}>
                        {t.label}
                    </button>
                )
            })}
            {props.extraContent ? (
                <div className={classes.tabs.flex}>
                    <div className={classes.tabs.extraContent}>{props.extraContent}</div>
                </div>
            ) : null}
        </div>
    )
}

const classes = {
    tabs: {
        wrap: "flex space-x-6 md:space-x-4 text-15 md:text-16 border-b border-gray-200 w-full",
        tab: "font-semibold flex h-full flex-col pb-3 justify-center px-5 bg-transparent cursor-pointer text-black/70 group hover:text-primary-color transition -mb-px leading-5",
        tabActive: "text-primary-color border-b-[2px] border-primary-color opacity-100",
        disabled: "pointer-events-none opacity-50",
        flex: "flex-1",
        extraContent: "relative bottom-[2px] text-right",
    },
}
